import React, { useEffect, useState } from "react";
import { Dialog } from "@headlessui/react"; // install @headlessui/react
import Button from "../../../components/ui/Button"; // default export assumed
import * as XLSX from "xlsx";
import axios from "axios";
import { toast } from "react-toastify";
import AxiosService from "utils/AxiosService";
import UseProductHook from "hooks/UseProductHook";

const ImportProductsModal = ({ isOpen, onClose }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const {getAllProduct} = UseProductHook()

  // Download sample Excel
  const handleDownloadSample = () => {
    const sampleData = [
      { name: "Sample Product", price: 100, category: "product", status: "active" },
    ];

    const worksheet = XLSX.utils.json_to_sheet(sampleData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Products");

    XLSX.writeFile(workbook, "sample_products.xlsx");
  };
  
  // Upload Excel
 const handleUpload = async () => {
  if (!file) {
    toast.error("Please select an Excel file");
    return;
  }

  setUploading(true);
  try {
    const reader = new FileReader();

    reader.onload = async (e) => {
      try {
        const data = new Uint8Array(e.target.result);
        const workbook = XLSX.read(data, { type: "array" });

        // Get the first sheet
        const sheetName = workbook.SheetNames[0];
        const sheet = workbook.Sheets[sheetName];

        // Convert sheet to JSON
        const jsonData = XLSX.utils.sheet_to_json(sheet);

        // Send to backend API
        const res = await AxiosService.post("/vendor/bulkuploadProducts", {
          products: jsonData,
        });

        await getAllProduct()
        toast.success(res.data.message || "Products imported successfully!");
        setFile(null);
        onClose();
        window.location.reload();
      } catch (error) {
        console.error(error);
        toast.error(error.response?.data?.message || "Failed to import products");
      } finally {
        setUploading(false);
      }
    };

    reader.readAsArrayBuffer(file); // start reading file
  } catch (err) {
    console.error(err);
    toast.error("Failed to read Excel file");
    setUploading(false);
  }
};


  return (
    <Dialog open={isOpen} onClose={onClose} className="relative z-50">
      {/* Overlay */}
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      {/* Modal content */}
      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
          <Dialog.Title className="text-lg font-bold mb-4">
            Import Products
          </Dialog.Title>

          {/* File input */}
          <input
            type="file"
            accept=".xlsx,.xls"
            onChange={(e) => setFile(e.target.files[0])}
            className="mb-4"
          />

          {/* Actions */}
          <div className="flex justify-between">
            <Button variant="outline" onClick={handleDownloadSample}>
              Download Sample
            </Button>

            <Button
              variant="default"
              onClick={handleUpload}
              disabled={uploading}
            >
              {uploading ? "Uploading..." : "Upload Excel"}
            </Button>
          </div>

          {/* Close button */}
          <div className="mt-4 text-right">
            <Button variant="ghost" onClick={onClose}>
              Close
            </Button>
          </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default ImportProductsModal;
